import domready from 'domready'
import fixPublicPath from '../lib/fix-public-path'
import { fixVhBug, checkHasVhBug } from '@nrk/dh-vh'
import { rootClassName } from './client.html'

if (__IS_LEGACY__) {
  require('core-js/stable')
}

const el = document.querySelector(`.${rootClassName}`)
const staticHost = el.getAttribute('data-static-host')
if (staticHost) {
  fixPublicPath(staticHost)
}

domready(async () => {
  if (checkHasVhBug()) {
    fixVhBug()
  }

  if (!('IntersectionObserver' in window)) {
    try {
      await import('intersection-observer' /* webpackChunkName: "intersection-observer" */)
    } catch (e) {
      // More than one module might be loading the polyfill at the same time.
      console.error(e)
    }
  }

  if (!('customElements' in window)) {
    await import(
      '@webcomponents/custom-elements' /* webpackChunkName: "@webcomponents-custom-elements" */
    )
  }

  if (typeof customElements.get('dh-forklaringsscroll-app') === 'undefined') {
    customElements.define('dh-forklaringsscroll-app', require('./client').Client)
  }
})
